import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FigmaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.5 4.00195C3.5 4.81975 3.89267 5.54584 4.49976 6.00195C3.89267 6.45807 3.5 7.18415 3.5 8.00195C3.5 8.81975 3.89267 9.54584 4.49976 10.002C3.89267 10.4581 3.5 11.1842 3.5 12.002C3.5 13.3827 4.61929 14.502 6 14.502C7.38071 14.502 8.5 13.3827 8.5 12.002V10.0021C8.91783 10.316 9.4372 10.502 10 10.502C11.3807 10.502 12.5 9.38266 12.5 8.00195C12.5 7.18415 12.1073 6.45807 11.5002 6.00195C12.1073 5.54584 12.5 4.81975 12.5 4.00195C12.5 2.62124 11.3807 1.50195 10 1.50195H6C4.61929 1.50195 3.5 2.62124 3.5 4.00195ZM10 5.50195C10.8284 5.50195 11.5 4.83038 11.5 4.00195C11.5 3.17353 10.8284 2.50195 10 2.50195H8.5V5.50195H10ZM8.5 8.00195C8.5 8.83038 9.17157 9.50195 10 9.50195C10.8284 9.50195 11.5 8.83038 11.5 8.00195C11.5 7.17353 10.8284 6.50195 10 6.50195C9.17157 6.50195 8.5 7.17353 8.5 8.00195ZM7.5 9.50195H6C5.17157 9.50195 4.5 8.83038 4.5 8.00195C4.5 7.17353 5.17157 6.50195 6 6.50195H7.5V9.50195ZM6 10.502H7.5V12.002C7.5 12.8304 6.82843 13.502 6 13.502C5.17157 13.502 4.5 12.8304 4.5 12.002C4.5 11.1735 5.17157 10.502 6 10.502ZM7.5 5.50195H6C5.17157 5.50195 4.5 4.83038 4.5 4.00195C4.5 3.17353 5.17157 2.50195 6 2.50195H7.5V5.50195Z"
		></path>
	</svg>
))
